import Home from './Home';
import AktivasiKartu from './AktivasiKartu';
import BeliKartu from './BeliKartu';
import JualBitcoin from './JualBitcoin';
import TopupBitcoin from './TopupBitcoin';
import BeliKartuSelesai from './BeliKartuSelesai';
import BeliKartuVerifikasi from './BeliKartuVerifikasi';
import CekSaldo from './CekSaldo';
import CekSaldoDetail from './CekSaldoDetail';
import Referral from './Referral';
import Cashback from './Cashback';
import Voucher from './Voucher';
import Comission from './Comission';
import UpgradeCardRequest from './UpgradeCardRequest';
import NotFound from './core/components/Layout/NotFound';

const routes = [
  {
    path: '/',
    exact: true,
    name: 'Home',
    component: Home,
  },
  {
    path: '/cek-saldo-bitcoin',
    exact: true,
    name: 'Cek Saldo',
    component: CekSaldo,
  },
  {
    path: '/cek-saldo-bitcoin/:walletId',
    exact: true,
    name: 'Wallet',
    component: CekSaldoDetail,
  },
  {
    path: '/cek-saldo-bitcoin/:walletId/:historyMode',
    exact: true,
    name: 'Wallet',
    component: CekSaldoDetail,
  },
  {
    path: '/beli-bitcoin-kartu-selesai',
    exact: true,
    name: 'Beli Kartu',
    component: BeliKartuSelesai,
  },
  {
    path: '/aktivasi-kartu',
    exact: true,
    name: 'Aktivasi Kartu',
    component: AktivasiKartu,
  },
  {
    path: '/aktivasi-kartu/:stepId',
    exact: true,
    name: 'Aktivasi Kartu',
    component: AktivasiKartu,
  },
  {
    path: '/jual-bitcoin',
    exact: true,
    name: 'Jual Bitcoin',
    component: JualBitcoin,
  },
  {
    path: '/jual-bitcoin/:walletId',
    exact: true,
    name: 'Jual Bitcoin',
    component: JualBitcoin,
  },
  {
    path: '/top-up-bitcoin/:walletId',
    exact: true,
    name: 'Top Up Bitcoin',
    component: TopupBitcoin,
  },
  {
    path: '/beli-bitcoin-kartu',
    exact: true,
    name: 'Beli Kartu',
    component: BeliKartu,
  },
  {
    path: '/beli-bitcoin-kartu/:stepId',
    exact: true,
    name: 'Beli Kartu',
    component: BeliKartu,
  },
  {
    path: '/referral/:walletId',
    exact: true,
    name: 'Referral',
    component: Referral,
  },
  {
    path: '/cashback/:walletId',
    exact: true,
    name: 'Cashback',
    component: Cashback,
  },
  {
    path: '/voucher/:walletId',
    exact: true,
    name: 'Voucher',
    component: Voucher,
  },
  {
    path: '/komisi',
    exact: true,
    name: 'Comission',
    component: Comission,
  },
  {
    path: '/komisi/:walletId',
    exact: true,
    name: 'Comission',
    component: Comission,
  },
  {
    path: '/upgrade-kartu/:walletId',
    exact: true,
    name: 'Upgrade Kartu',
    component: UpgradeCardRequest,
  },
  {
    path: '/verifikasi-data',
    exact: true,
    name: 'Verifikasi Data',
    component: BeliKartuVerifikasi,
  },
  {
    path: '',
    exact: true,
    name: '404',
    component: NotFound,
  },
];

export default routes;
